export enum ScreenRotation {
  Landscape,
  Portrait,
  All
}


// WEBPACK FOOTER //
// /Users/zasa/map/map-core-git/~/tslint-loader??ref--0-1!./src/Browser/ScreenRotation.ts